const CamOffContainer = ({videoEnabled}) =>{
    return <div style={{display:videoEnabled?"none":"block"}}  className="camOff center ">
    <div className="jumbotron vertical-center">
<div className="container">
Camera is off
</div>
</div></div>;
}
export default CamOffContainer;